import { render, staticRenderFns } from "./PotentialResourcesValid.vue?vue&type=template&id=053277bc&scoped=true&"
import script from "./PotentialResourcesValid.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesValid.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesValid.vue?vue&type=style&index=0&id=053277bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053277bc",
  null
  
)

export default component.exports